import { useCallback } from 'react';

import { useLazyQuery } from '@apollo/client/react';

import { AnyChatSaleChannelType } from '@anyx/common-graphql';
import { reportAppError } from '@anyx/shared-utils';

import { SEARCH_MKP_LISTING_V2 } from '../graphql';

interface UseGetMkpListingOptions {
  storeId: string;
}

type Options = {
  label: string;
  value: string;
};

export type GetMkpListingOptions = (listingId?: string) => (keyword?: string) => Promise<Options[]>;

export const useGetMkpListingOptions = ({ storeId }: UseGetMkpListingOptions) => {
  const [searchMkpListingQueryV2] = useLazyQuery(SEARCH_MKP_LISTING_V2);

  const getMkpListingOptionsV2: GetMkpListingOptions = useCallback(
    (listingId) => {
      return async (keyword) => {
        try {
          const { data } = await searchMkpListingQueryV2({
            variables: {
              input: {
                storeId: storeId,
                productId: listingId || null,
                filter: {
                  keyword: keyword || '',
                  saleChannels: [AnyChatSaleChannelType.SHOPIFY],
                },
                pageNumber: 1,
                pageSize: 50,
              },
            },
          });

          if (!data) throw new Error('No listing found');

          return (
            data.AnyChatSaleChannelProducts?.map(({ id, name }) => ({
              label: name,
              value: id,
            })) || []
          );
        } catch (error) {
          reportAppError(error);
          return [];
        }
      };
    },
    [searchMkpListingQueryV2, storeId]
  );

  return {
    getMkpListingOptions: getMkpListingOptionsV2,
  };
};
